import { render, staticRenderFns } from "./DeletePageDialog.vue?vue&type=template&id=47ceca24&"
import script from "./DeletePageDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports